import { Component } from '@angular/core';
import {PetDto} from '../../../../api/api-client';
import {DialogService, DynamicDialogRef} from 'primeng/dynamicdialog';
import {TranslationPipe} from '../../../../pipes/translation.pipe';
import {DateTime} from 'luxon';
import {TranslationService} from '../../../../services/translation.service';

@Component({
  selector: 'app-pet-details-dialog',
  imports: [
    TranslationPipe
  ],
  templateUrl: './pet-details-dialog.component.html',
  styleUrl: './pet-details-dialog.component.scss',
})
export class PetDetailsDialogComponent {
  pet!:PetDto

  constructor(public ref: DynamicDialogRef, private readonly dialogService: DialogService, private readonly translationService:TranslationService) {
    this.pet = <PetDto>this.dialogService.getInstance(this.ref)?.data;
  }

  getAge(dateOfBirth: DateTime | undefined) {
    if (dateOfBirth) {
      const age = DateTime.now().diff(dateOfBirth);
      if (age.as("months") < 0) {
        return age.as("days").toFixed() + " " + this.translationService.translate("Date.Days");
      }
      if (age.as("years") < 2) {
        return age.as("months").toFixed() + " " + this.translationService.translate("Date.Months");
      } else {
        return age.as("years").toFixed() + " " + this.translationService.translate("Date.Years");
      }
    }
    return "";
  }

  getDate(date: DateTime | undefined):string|undefined {
    if (date) {
      return date.toLocaleString({day: '2-digit', month: '2-digit', year: 'numeric'});
    }
    return undefined;
  }

}
